import { createNgReactBridgeDirective } from '../../react-bridge'
import { AiHowToFix } from '../../../components/ai-ml'

export const reactAiHowToFix = createNgReactBridgeDirective(
  'reactAiHowToFix',
  [],
  AiHowToFix,
  ['applicationId', 'vulnerabilityId']
)
